const businessLandingES = {
	hero: {
		title: "Tu negocio, creciendo y sin estrés",
		subtitle:
			"Si tienes un negocio o quieres empezar uno, Sin Fila automatiza reservas, recordatorios y la gestión de tu equipo, y te ayuda a atraer más clientes.",
		primaryCta: "Registrar negocio gratis",
		storeText: "Available on iOS . Android",
		noteStrong:
			"Configura tu negocio en solo 15 min ",
		noteRest: "· Sin complicaciones ni contratos · Cancela en cualquier momento",
	},

	problem: {
		title: "El problema real",
		subtitle: "¿Te pasa esto?",
		items: [
			"📱 Respondes WhatsApp todo el día (y de noche)",
			"📆 Horarios cruzados o espacios vacíos",
			"🚶 Clientes llegan, ven fila larga… y se van",
			"😤 Llegan todos al mismo tiempo",
			"📊 No saber cuántos clientes atendiste este mes",
		],
		itemspart2: [
			"Si no hay nadie → pierdes tiempo.",
			"Si hay demasiada fila → pierdes clientes."
		],
		description:
			"💸 Cada cliente que se va por la fila es dinero perdido.",
		highlight:
			"👉 Muchos negocios pierden hasta 20% de sus ingresos por gestión de citas, tiempos muertos y clientes que se van al esperar.",
	},

	didYouKnow: {
		title: "Sabías que...",
		items: [
			"Más del 70% de los clientes prefieren reservar online si pueden",
			"Automatizar citas te saca del WhatsApp todo el día",
			"Los recordatorios reducen ausencias",
			"Tener visibilidad online trae clientes nuevos sin pagar anuncios",
		],
		highlight:
			"✅ Sin Fila organiza tu agenda para que no pierdas clientes y te da visibilidad online para crecer tu negocio.",
	},

	solution: {
		title: "Sin Fila lo soluciona",
		points: [
			{
				title: "Nunca pierdas una reserva",
				desc: "Todas tus citas, confirmaciones y recordatorios en un solo lugar.",
			},
			{
				title: "Atrae nuevos clientes y llena tu agenda",
				desc: "Muestra tu negocio a más clientes en nuestro marketplace.",
			},
			{
				title: "Ahorra tiempo gestionando tu negoico  y tu equipo",
				desc: "Administra tus servicios y los calendarios de tu personal sin esfuerzo.",
			},
			{
				title: "Reservas fáciles para tus clientes",
				desc: "Tus clientes reservan, modifican y reciben recordatorios automáticamente.",
			},
		],
		screens: {
			title: "Explora 4 pantallas",
			items: [
				"Calendario (multi)",
				"Explorar negocios",
				"Gestionar página del negocio",
				"Pantalla de reserva",
			],
		},
	},

	pricing: {
		title: "Un plan simple, todo incluido",
		planTitle: "Un plan sencillo — paga solo por lo que usas:",
		planItems: [
			"💳 $15 USD / mes — primer usuario",
			"👥 $12 USD / mes — por cada usuario adicional",
		],
		note:
			"Sin contratos. Sin cargos escondidos. Cancela cuando quieras.",
		autoTitle: "Pagar Sin Fila es simple y automático:",
		autoItems: [
			"Aceptamos tarjetas de crédito y débito directamente en la plataforma",
			"El cobro se realiza mensualmente de forma automática",
			"Puedes cancelar en cualquier momento, sin contratos ni permanencias",
		],
	},

	referral: {
		banner:
			"Programa de referido para darte meses gratis!! Un referido, un usuario gratis por mes!!",
		steps: [
			"Paso 1: envía tu código de referido",
			"Paso 2: el invitado completa su registro",
			"Paso 3: ambos obtienen un mes gratis para un usuario",
			"* Detalles disponibles en la app",
		],
	},

	final: {
		text:
			"Empieza gratis ahora y aprovecha nuestro programa de referidos",
		button: "Registrar negocio gratis",
	},
};

export default businessLandingES;